._label_1der7_1 .label.label-switch {
  font-size: 12px !important; }
